import api from './api';

interface IParametro {
  id?: number;
  empresa_id: number;
  descricao: string;
  role: any;
}

export interface IEmpresa {
  id: number;
  endereco: {
    logradouro: string;
    bairro: string;
    estado: string;
    cidade: string;
    numero: string;
    cep: string;
    complemento: string;
  };
}

const empresaApi = {
  getParametro: async (id: number, descricao: string): Promise<IParametro> => {
    const { data } = await api.get(`/parametro`, {
      params: {
        descricao: descricao,
        empresa_id: id
      }
    });
    return data;
  },
  postParametro: async (parametro: IParametro) => {
    const { data } = await api.post(`/parametro`, parametro);
    return data;
  },
  deleteTaxa: async (id: number) => {
    const { data } = await api.delete(`/taxa_entrega/${id}`);
    return data;
  },
  getCompany: async (id: number): Promise<IEmpresa> => {
    const { data } = await api.get(`/empresa/${id}`);
    return data;
  },
};

export default empresaApi;